import { Diamond } from "lucide-react";

const ITEMS = ["THE RAYAN", "SRINAGAR", "KASHMIRI WALNUT CRAFT", "DAL LAKE", "BOUTIQUE LUXURY", "KAHWA HOSPITALITY"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="mx-10 font-display text-lg font-light italic tracking-[0.2em] text-[#8C713B]">{t}</span>
        <Diamond size={9} className="text-[#C5A059]" fill="#C5A059" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#2A2421] bg-[#0D0B0A] py-5">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
